package redmcrosco.alex.farmatch

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import farmatch.composeapp.generated.resources.Res
import farmatch.composeapp.generated.resources.*
import farmatch.composeapp.generated.resources.farmatch_logo_00
import androidx.compose.runtime.key
import redmcrosco.alex.farmatch.ui.BackHandler
import redmcrosco.alex.farmatch.ui.LocalAppLocale
import redmcrosco.alex.farmatch.ui.AppEnvironment
import redmcrosco.alex.farmatch.models.AnnuncioTurno
import redmcrosco.alex.farmatch.models.Farmacia
import redmcrosco.alex.farmatch.models.Farmacista
import redmcrosco.alex.farmatch.models.LoginRequest
import redmcrosco.alex.farmatch.models.UserRole
import redmcrosco.alex.farmatch.ui.AppIcons
import redmcrosco.alex.farmatch.ui.AuthViewModel
import redmcrosco.alex.farmatch.ui.DisponibilitaScreen
import redmcrosco.alex.farmatch.ui.FarmaciaScreen
import redmcrosco.alex.farmatch.ui.FarmacistaScreen
import redmcrosco.alex.farmatch.ui.HomeScreen
import redmcrosco.alex.farmatch.ui.ForgotPasswordDialog
import redmcrosco.alex.farmatch.ui.LoginScreen
import redmcrosco.alex.farmatch.ui.PreferitiScreen
import redmcrosco.alex.farmatch.ui.ProfileDetailScreen
import redmcrosco.alex.farmatch.ui.ProfileScreen
import redmcrosco.alex.farmatch.ui.RegisterScreen
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import redmcrosco.alex.farmatch.ui.NotificationScreen
import redmcrosco.alex.farmatch.ui.SupportoScreen
import redmcrosco.alex.farmatch.ui.SettingsScreen
import redmcrosco.alex.farmatch.ui.TutorialScreen
import redmcrosco.alex.farmatch.ui.StoricoScreen
import redmcrosco.alex.farmatch.ui.toCreatoreTipo

// Definizione Colori "Farmatch Theme"
val FarmatchMedicalGreen = Color(0xFF00A388)
val FarmatchTeal = Color(0xFF4DB6AC)

val FarmatchLightBlue = Color(0xFF47C1FF)
val FarmatchWhite = Color(0xFFFFFFFF)

private val LightColorScheme = lightColorScheme(
    primary = FarmatchMedicalGreen,
    secondary = FarmatchTeal,
    tertiary = Color(0xFF81D4FA),
    background = FarmatchWhite,
    surface = FarmatchWhite,
    onPrimary = FarmatchWhite,
    onSecondary = FarmatchWhite,
    onTertiary = Color.Black,
    onBackground = Color.Black,
    onSurface = Color.Black,
)

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun App(
    onOpenCalendar: (AnnuncioTurno) -> Unit = {},
    onExit: () -> Unit = {},
    platformContext: Any? = null
) {
    val authViewModel: AuthViewModel = viewModel { AuthViewModel() }

    // Inizializza lo storage per la persistenza locale subito
    LaunchedEffect(platformContext) {
        authViewModel.initStorage(platformContext)
    }

    val currentLanguage = authViewModel.selectedLanguage

    // Stati di navigazione sollevati sopra AppEnvironment per persistere al cambio lingua
    var selectedTab by remember { mutableStateOf(0) }
    var showPreferiti by remember { mutableStateOf(false) }
    var showSupporto by remember { mutableStateOf(false) }
    var showSettings by remember { mutableStateOf(false) }
    var showRegister by remember { mutableStateOf(false) }
    var showForgotPassword by remember { mutableStateOf(false) }
    var showNotifications by remember { mutableStateOf(false) }
    var showTutorial by remember { mutableStateOf(false) }
    var showStorico by remember { mutableStateOf(false) }
    var showExitDialog by remember { mutableStateOf(false) }

    var detailFarmacista by remember { mutableStateOf<Farmacista?>(null) }
    var detailFarmacia by remember { mutableStateOf<Farmacia?>(null) }

    // Gestione tasto Back (Android/KMP)
    BackHandler(enabled = true) {
        when {
            showSettings -> showSettings = false
            showNotifications -> showNotifications = false
            showTutorial -> showTutorial = false
            showStorico -> showStorico = false
            showPreferiti -> showPreferiti = false
            showSupporto -> showSupporto = false
            detailFarmacista != null || detailFarmacia != null -> {
                detailFarmacista = null
                detailFarmacia = null
            }
            showRegister -> showRegister = false
            selectedTab != 0 -> selectedTab = 0
            else -> showExitDialog = true
        }
    }

    AppEnvironment(currentLanguage) {
        MaterialTheme(colorScheme = LightColorScheme) {
            val farmacisti = remember { mutableStateListOf<Farmacista>() }
            val farmacie = remember { mutableStateListOf<Farmacia>() }
            val annunci = remember { mutableStateListOf<AnnuncioTurno>() }


            if (showExitDialog) {
                androidx.compose.material3.AlertDialog(
                    onDismissRequest = { showExitDialog = false },
                    title = { Text(stringResource(Res.string.exit_app_title)) },
                    text = { Text(stringResource(Res.string.exit_app_confirm)) },
                    confirmButton = {
                        androidx.compose.material3.TextButton(onClick = onExit) {
                            Text(stringResource(Res.string.yes))
                        }
                    },
                    dismissButton = {
                        androidx.compose.material3.TextButton(onClick = { showExitDialog = false }) {
                            Text(stringResource(Res.string.no))
                        }
                    }
                )
            }

            Surface(modifier = Modifier.fillMaxSize(), color = Color.Transparent) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(
                            Brush.verticalGradient(
                                colors = listOf(Color(0xFFF8FAFC), Color(0xFFE4EFF7))
                            )
                        )
                ) {
                    if (showSettings) {
                    SettingsScreen(
                        onBack = { showSettings = false },
                        currentLanguage = currentLanguage,
                        onLanguageChange = { 
                            authViewModel.updateLanguage(it)
                        },
                        selectedColor = authViewModel.selectedThemeColor,
                        onColorChange = { authViewModel.updateThemeColor(it) }
                    )
                } else if (showNotifications) {
                    NotificationScreen(
                        viewModel = authViewModel,
                        onBack = { showNotifications = false }
                    )
                } else if (showTutorial) {
                    TutorialScreen(
                        onBack = { showTutorial = false }
                    )
                } else if (showStorico) {
                    StoricoScreen(
                        viewModel = authViewModel,
                        onBack = { showStorico = false }
                    )
                } else if (authViewModel.currentUserRole == null) {
                    if (showRegister || authViewModel.registrationSuccess) {
                        RegisterScreen(
                            viewModel = authViewModel,
                            onBackToLogin = { 
                                showRegister = false 
                                authViewModel.registrationSuccess = false
                            },
                            onSettingsClick = { showSettings = true },
                            currentLanguage = currentLanguage,
                            onLanguageChange = { authViewModel.updateLanguage(it) }
                        )
                    } else {
                        LoginScreen(
                            onLoginSuccess = { email, pass ->
                                authViewModel.login(LoginRequest(email, pass))
                            },
                            onRegisterClick = { showRegister = true },
                            onSettingsClick = { showSettings = true },
                            currentLanguage = currentLanguage,
                            onLanguageChange = { authViewModel.updateLanguage(it) },
                            isLoading = authViewModel.isLoading,
                            errorMessage = authViewModel.errorMessage,
                            rememberMe = authViewModel.rememberMe,
                            onRememberMeChange = { authViewModel.updateRememberMe(it) },
                            initialEmail = authViewModel.savedEmail,
                            onForgotPasswordClick = { showForgotPassword = true }
                        )
                        if (showForgotPassword) {
                            ForgotPasswordDialog(
                                viewModel = authViewModel,
                                onDismiss = { showForgotPassword = false }
                            )
                        }
                    }
                } else if (showPreferiti) {
                    PreferitiScreen(
                        viewModel = authViewModel,
                        onBack = { showPreferiti = false },
                        onViewProfile = { id, targetRole ->
                            if (targetRole == UserRole.FARMACISTA) {
                                authViewModel.getFarmacistaById(id) { detailFarmacista = it }
                            } else {
                                authViewModel.getFarmaciaById(id) { detailFarmacia = it }
                            }
                            showPreferiti = false
                        }
                    )
                } else if (showSupporto) {
                    SupportoScreen(
                        viewModel = authViewModel,
                        onBack = { showSupporto = false }
                    )
                } else if (detailFarmacista != null || detailFarmacia != null) {
                    ProfileDetailScreen(
                        farmacista = detailFarmacista,
                        farmacia = detailFarmacia,
                        viewModel = authViewModel,
                        onBack = { 
                            detailFarmacista = null
                            detailFarmacia = null
                        }
                    )
                } else {
                    val role = authViewModel.currentUserRole
                    Scaffold(
                        containerColor = Color.Transparent,
                        topBar = {
                            CenterAlignedTopAppBar(
                                navigationIcon = {
                                    IconButton(onClick = { showTutorial = true }) {
                                        Icon(
                                            imageVector = AppIcons.Support,
                                            contentDescription = "Tutorial",
                                            tint = MaterialTheme.colorScheme.primary
                                        )
                                    }
                                },
                                title = {
                                    Image(
                                        painter = painterResource(Res.drawable.farmatch_logo_00),
                                        contentDescription = "Farmatch Logo",
                                        modifier = Modifier.height(60.dp) // Ingrandito da 40.dp a 60.dp
                                    )
                                },
                                actions = {
                                    IconButton(onClick = { showNotifications = true }) {
                                        BadgedBox(
                                            badge = {
                                                if (authViewModel.unreadNotificationsCount > 0) {
                                                    Badge { Text(authViewModel.unreadNotificationsCount.toString()) }
                                                }
                                            }
                                        ) {
                                            Icon(
                                                imageVector = AppIcons.Notifications,
                                                contentDescription = "Notifications",
                                                tint = Color(0xFFFFD600) // Giallo Campanellina
                                            )
                                        }
                                    }
                                    IconButton(onClick = { showSettings = true }) {
                                        Icon(
                                            imageVector = AppIcons.Settings,
                                            contentDescription = "Settings",
                                            tint = Color.Gray // Ingranaggio Grigio
                                        )
                                    }
                                    IconButton(onClick = { authViewModel.logout() }) {
                                        Icon(
                                            imageVector = AppIcons.Logout, 
                                            contentDescription = "Logout", 
                                            tint = MaterialTheme.colorScheme.error
                                        )
                                    }
                                },
                                colors = TopAppBarDefaults.centerAlignedTopAppBarColors(
                                    containerColor = Color.Transparent
                                )
                            )
                        },
                        bottomBar = {
                            val role = authViewModel.currentUserRole
                            val newMatchesCount = authViewModel.currentMatches.count { match ->
                                val isProposer = match.propostoDa == role?.toCreatoreTipo()
                                match.stato == redmcrosco.alex.farmatch.models.MatchStato.PROPOSTO && !isProposer
                            }

                            Surface(
                                modifier = Modifier
                                    .padding(horizontal = 16.dp, vertical = 12.dp)
                                    .navigationBarsPadding(),
                                color = Color.Transparent
                            ) {
                                Card(
                                    modifier = Modifier.fillMaxWidth(),
                                    colors = CardDefaults.cardColors(
                                        containerColor = Color.White.copy(alpha = 0.8f) // Fisso Bianco Cristallino
                                    ),
                                    shape = RoundedCornerShape(20.dp),
                                    border = androidx.compose.foundation.BorderStroke(
                                        width = 0.5.dp,
                                        color = Color(0xFFC0C0C0).copy(alpha = 0.3f) // Ancora più tenue
                                    ),
                                    elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
                                ) {
                                    NavigationBar(
                                        containerColor = Color.Transparent,
                                        tonalElevation = 0.dp,
                                        modifier = Modifier.height(72.dp)
                                    ) {
                                        val navColors = androidx.compose.material3.NavigationBarItemDefaults.colors(
                                            indicatorColor = Color(0xFFE1F5FE), // Celeste / Blu Chiaro
                                            selectedIconColor = MaterialTheme.colorScheme.primary,
                                            unselectedIconColor = Color.Gray
                                        )

                                        NavigationBarItem(
                                            selected = selectedTab == 0,
                                            onClick = { selectedTab = 0 },
                                            label = { Text(stringResource(Res.string.tab_home), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = {
                                                BadgedBox(
                                                    badge = {
                                                        if (newMatchesCount > 0) {
                                                            Badge { Text(newMatchesCount.toString()) }
                                                        }
                                                    }
                                                ) {
                                                    Icon(AppIcons.Home, contentDescription = "Home")
                                                }
                                            }
                                        )

                                        NavigationBarItem(
                                            selected = selectedTab == 1,
                                            onClick = { selectedTab = 1 },
                                            label = { Text(stringResource(Res.string.tab_ads), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.List, contentDescription = "Annunci") }
                                        )

                                        NavigationBarItem(
                                            selected = selectedTab == 2,
                                            onClick = { selectedTab = 2 },
                                            label = { Text(stringResource(Res.string.tab_search), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.Search, contentDescription = "Ricerca") }
                                        )
                                        
                                        NavigationBarItem(
                                            selected = selectedTab == 3,
                                            onClick = { selectedTab = 3 },
                                            label = { Text(stringResource(Res.string.tab_profile), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.Account, contentDescription = "Profilo") }
                                        )
                                    }
                                }
                            }
                        }
                    ) { padding ->
                        Column(modifier = Modifier.fillMaxSize().padding(padding)) {
                            when (selectedTab) {
                                0 -> {
                                    val userName = if (role == UserRole.FARMACISTA) 
                                        authViewModel.currentUserFarmacista?.nome ?: "Farmacista"
                                    else 
                                        authViewModel.currentUserFarmacia?.nomeFarmacia ?: "Farmacia"
                                        
                                    HomeScreen(
                                        role = role, 
                                        userName = userName,
                                        viewModel = authViewModel,
                                        onOpenCalendar = onOpenCalendar,
                                        onViewProfile = { id, targetRole ->
                                            if (targetRole == UserRole.FARMACISTA) {
                                                authViewModel.getFarmacistaById(id) { detailFarmacista = it }
                                            } else {
                                                authViewModel.getFarmaciaById(id) { detailFarmacia = it }
                                            }
                                        }
                                    )
                                }
                                1 -> DisponibilitaScreen(viewModel = authViewModel)
                                2 -> { 
                                    if (role == UserRole.FARMACISTA) FarmaciaScreen(authViewModel)
                                    else FarmacistaScreen(authViewModel)
                                }
                                3 -> ProfileScreen(
                                        viewModel = authViewModel,
                                        currentLanguage = currentLanguage,
                                        onLanguageChange = { authViewModel.updateLanguage(it) },
                                        onLogout = { authViewModel.logout() },
                                        onNavigateToPreferiti = { showPreferiti = true },
                                        onNavigateToSupporto = { showSupporto = true },
                                        onNavigateToStorico = { showStorico = true }
                                    )
                            }
                        }
                    }
                }
            }
        }
    }
}
}
